import { Box, Stack, StackProps, Typography } from '@mui/material'
import NewDot from '@/components/common/NewDot/NewDot'
import useChangelog from '@/hooks/useChangelog'
import useTranslation from '@/hooks/useTranslation'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthContext } from '@/features/auth/context'
import classes from '@/features/config/components/common/style.module.scss'
import ErrorPage from '@/features/config/components/modal/NotificationModal/ErrorPage'
import { selectTheme } from '@/store/selectors/ThemeSelector'
import { mode_type } from '@/theme/types/constants'

const WhatsNewButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { isLogin } = useAuthContext()
  const location = useLocation()
  const { hasUnseen } = useChangelog()

  if (!isLogin) return null
  if (location.pathname === '/dashboard/changelog') return null

  return (
    <Typography
      onClick={() => navigate('/dashboard/changelog')}
      sx={{
        color: 'grey.600',
        fontSize: '12px',
        fontWeight: 400,
        cursor: 'pointer',
        textDecoration: 'underline',
        textUnderlineOffset: '4px',
        mr: 1,
        padding: '4px 8px',
        '&:hover': {
          color: 'primary.main',
        },
      }}
    >
      {t('WhatsNew')}
      {hasUnseen && <NewDot />}
    </Typography>
  )
}

interface HeaderProps {
  left?: React.ReactNode
  right?: React.ReactNode
  StackProps?: StackProps
  className?: any
  isSetupPage?: boolean
}

const Header = ({
                  left,
                  right,
                  StackProps = {},
                  isSetupPage,
                  ...rest
                }: HeaderProps) => {
  const themeMode = useSelector(selectTheme)
  const location = useLocation()

  const isAdminPage = location.pathname.startsWith('/admin')
  return (
    <Stack
      sx={{
        height: '48px',
        borderBottom: {
          ...(themeMode === mode_type.dark
            ? { borderBottom: '1px solid #2a4552' }
            : { borderBottom: '1px solid #d7d7d7' }),
        },
      }}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      {...StackProps}
      {...rest}
    >
      <Box>{left}</Box>
      <Box className={classes.headEr}>
        {!isAdminPage && <ErrorPage isSetupPage={isSetupPage} />}
        <WhatsNewButton />
        {right}
      </Box>
    </Stack>
  )
}

export default Header
